import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ShieldCheck, Zap } from 'lucide-react';
import { Button } from '../ui/button';
import SocialProofBar from '../SocialProofBar';

export default function PriceSection({ course, onBuy }) {
  if (!course) return null;

  return (
    <section id="offer" className="py-16 sm:py-20 px-6 bg-white text-[#0B0B0B] border-y border-[#0B0B0B]/5" data-testid="price-section">
      <div className="container mx-auto max-w-5xl">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.6 }}
          className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12"
        >
          <div className="text-center lg:text-left shrink-0" data-testid="offer-price">
            <div className="flex items-baseline justify-center lg:justify-start gap-3">
              <span className="text-2xl font-semibold text-[#0B0B0B]/30 line-through" style={{ fontFamily: 'Clash Display' }}>$89</span>
              <span className="text-6xl font-bold" style={{ fontFamily: 'Clash Display' }}>$49</span>
            </div>
            <div className="text-sm text-[#0B0B0B]/50 mt-1">once-off · instant access · charged as R{course.price.toFixed(0)} ZAR</div>
          </div>

          <div className="flex-1 w-full">
            <Button
              data-testid="offer-cta-btn"
              onClick={() => onBuy({ package_type: 'course', course_id: course.id, title: course.title, price: course.price, display_price: '$49' })}
              className="w-full bg-[#0B0B0B] text-white hover:bg-[#2a2a2a] rounded-xl py-8 text-lg sm:text-xl font-bold transition-transform hover:scale-[1.02] active:scale-[0.98]"
            >
              Get Instant Access <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
            <div className="flex flex-col sm:flex-row justify-center gap-3 sm:gap-8 mt-4 text-sm text-[#0B0B0B]/60">
              <span className="inline-flex items-center justify-center gap-1.5"><ShieldCheck className="w-4 h-4" /> No account needed. Pay securely.</span>
              <span className="inline-flex items-center justify-center gap-1.5"><Zap className="w-4 h-4" /> Instant access after payment.</span>
            </div>
            <div className="flex justify-center lg:justify-start">
              <SocialProofBar />
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
